export const ASEAN_INTELLIGENCE_INITIAL_STATE: AseanIntelligenceSubmitState = {
  success: false,
  message: "Form submission failed!",
  errors: {},
  fields: {},
};
